//
import Model from '@/models/Model'
import ProductModel from '@/models/Warehouse/WhProduct'
import ConfirmModel from '@/models/Actions/AConfirm'
import InArmedModel from '@/models/Actions/AInArmed'
import InArmedToRevisionModel from '@/models/Actions/AInArmedToRevision'
import InvoiceCommentModel from '@/models/Actions/AInvoiceComment'
import InRevisionToArmedModel from '@/models/Actions/AInRevisionToArmed'
import AReceiveModel from '@/models/Actions/AReceive'
import PrintJobDispatchRequest from '@/models/General/GPrintJobDispatchRequest'

//
export default class WhDispatchRequest extends Model {
    //
    pos_sale_payment_types = []
    wh_selected_dispatch_requests = []
    /**
     *
     */
    inArmed() {
        return this.hasMany(InArmedModel)
    }
    /**
     *
     */
    inArmedToRevision() {
        return this.hasMany(InArmedToRevisionModel)
    }
    /**
     *
     */
    invoiceComment() {
        return this.hasMany(InvoiceCommentModel)
    }
    /**
     *
     */
    inRevisionToArmed() {
        return this.hasMany(InRevisionToArmedModel)
    }
    /**
     *
     */
    confirm() {
        return this.hasMany(ConfirmModel)
    }
    /**
     * the dispatch batch model errors
     */
    static errors = {
        sl_customer_branch_offices_id: {
            name: 'Sucursal del cliente',
            translates: [
                {
                    translate: ' sl customer branch offices id ',
                    value: ' ',
                },
            ],
        },
        wh_detail_dispatch_request: {
            name: 'Lista de productos',
            translates: [
                {
                    translate: ' wh detail dispatch request ',
                    value: ' ',
                },
            ],
        },
    }

    get bill_state_str() {
        return this.sl_sale_ticket
            ? 'Boleteado'
            : this.sl_sale_invoice
                ? 'Facturado'
                : '-'
    }

    /**
     * { property_description }
     *
     * @type       {boolean}
     */
    get can_arm() {
        return this.g_state_id === 23
    }

    /**
     * get can the dispatch batch dispatch
     */
    get can_confirm() {
        return this.g_state_id === 41
    }

    /**
     * get can the dispatch batch dispatch
     */
    get can_edit() {
        return this.g_state_id < 24
    }

    /**
     * 
     */
    get can_receive() {
        return this.g_state_id == 25 || this.g_state_id == 33
    }

    /**
     * get can the dispatch batch dispatch
     */
    get can_revision() {
        return this.g_state_id === 40
    }

    /**
     *
     */
    get g_seller_user_id() {
        return this.getProperty('pos_sale.g_seller_user_id', '-')
    }

    /**
     *
     */
    get g_seller_user_full_name() {
        return this.getProperty(
            'pos_sale.g_seller_user.hr_employee.name_case',
            '-'
        ) //[
        /*    this.pos_sale.g_seller_user.hr_employee.names,
            this.pos_sale.g_seller_user.hr_employee.last_name1,
            this.pos_sale.g_seller_user.hr_employee.last_name2,
        ].join(' ')*/
    }

    /**
     *
     */
    get g_state_name() {
        //console.log(this.g_state)
        return this.g_state.state
    }

    /**
     * get if has detail
     */
    get has_detail() {
        return this.wh_detail_dispatch_requests
    }

    /**
     * get if has sale payment type
     */
    get has_sale_payment_type() {
        return !!this.pos_sale_payment_types
    }

    /**
     * get if has state
     */
    get has_state() {
        return !!this.g_state
    }

    /**
     *
     */
    get pos_sale_payment_types_str() {
        return this.pos_sale_payment_types.length > 0
            ? this.pos_sale_payment_types.map(({ type }) => type)
            : 'Sin especificar'
    }

    /**
     *
     */
    get pch_payment_condition_type() {
        return String(
            this.pch_payment_condition ? this.pch_payment_condition.type : '-'
        )
    }

    /**
     *
     */
    get sl_customer_alias_name() {
        return this.sl_customer.alias_name
    }

    /**
     *
     */
    get sl_customer_branch_offices_address() {
        return this.sl_customer_branch_offices.address
    }

    /**
     * { property_description }
     * @type       {<type>}
     */
    get sl_customer_branch_offices_g_commune_name() {
        return this.getProperty('sl_customer_branch_offices.g_commune.name', '-')
    }

    /**
     *
     */
    get sl_customer_business_name() {
        return this.sl_customer.business_name
    }
    
    /**
     * { property_description }
     * @type       {<type>}
     */
    get sl_customer_branch_offices_g_commune_name() {
        return this.getProperty('sl_customer_branch_offices.g_commune.name', '-')
    }

    /**
     *
     */
    get sl_customer_rut() {
        return this.sl_customer.rut
    }

    /**
     * 
     */
    get sl_sale_number() {
        return this.getProperty('sl_sale_invoice.number', 0) || this.getProperty('sl_sale_ticket.number', 0)
    }

    get pos_sale_customer_credit_option() {
        return ''
    }

    /**
     * 
     */
    filterByReceived(item) {
        return item.received_at == null
    }

    /**
     *
     */
    static includes = [
        'g_state',
        'pch_payment_condition',
        'pos_sale.g_seller_user.hr_employee',
        'pos_sale.payment_types',
        'pos_sale.pos_detail_sales.wh_product',
        'sl_customer',
        'sl_customer_branch_offices',
        'wh_detail_dispatch_requests.wh_product',
        'wh_detail_dispatch_requests.wh_warehouse',
    ]

    /**
     * the dispatch batch detail map
     */
    mapDetail = ({ id, received, received_at, quantity_requested, wh_product, wh_warehouse, move_to_warehouse }) =>
        new ProductModel({
            received,
            quantity_requested,
            received_at,
            wh_detail_dispatch_request_id: id,
            ...wh_product,
            wh_warehouse,
            move_to_warehouse,
        })

    /**
     * the dispatch batch selected map
     */
    mapSelected = ({ quantity_requested, id, wh_warehouse }) => ({
        quantity_requested,
        wh_product_id: id,
        wh_warehouse_id: wh_warehouse.id,
    })

    /**
     * 
     */
    mapReceiveDetail = item => ({
        id: item.wh_detail_dispatch_request_id,
        received: item.received,
        move_to_warehouse: item.move_to_warehouse,
    })

    /**
     * 
     */
    receive() {
        return this.hasMany(AReceiveModel)
    }

    /**
     *
     */
    reset() {
        //
        this.pos_sale_payment_types = this.pos_sale.payment_types
        this.pos_customer_credit_option_id = this.pos_sale.pos_customer_credit_option_id
        //
        this.wh_selected_dispatch_requests = this.has_detail
            ? this.wh_detail_dispatch_requests.map(this.mapDetail)
            : []

        //
        return this
    }

    /**
     *
     */
    resource() {
        return 'wh_dispatch_request'
    }

    /**
     *
     */
    set g_seller_user_id(id) {
        this.pos_sale.g_seller_user_id = id
    }
    /**
     * 
     */
    toInvoiceComment() {
        return {
            invoice_comment: this.sale_comment,
        }
    }
    /**
     * 
     */
    toPrintJob() {
        return new PrintJobDispatchRequest({ 
            id: this.id 
        })
    }

    toReceive() {
        
        //
        this.wh_detail_dispatch_request = this.wh_selected_dispatch_requests.filter(this.filterByReceived).map(this.mapReceiveDetail)
        
        //
        return this.clean([
            'reception_comment',
            'wh_detail_dispatch_request',
        ])
    }

    /**
     * 
     */
    toUpdate() {

        //
        //this.pos_customer_credit_option_id = this.pch_payment_condition_id,

        //
        this.wh_detail_dispatch_request = this.wh_selected_dispatch_requests.map(
            this.mapSelected
        )

        //
        return this.clean([
            'description',
            'id',
            'pos_customer_credit_option_id',
            'sl_customer_branch_offices_id',
            'wh_detail_dispatch_request',
        ])
    }

    /**
     *
     */
    update() {
        //
        //this.dispatch_date = this.dispatch_date ? this.dispatch_date.split(" ").shift() : ""
        //this[ "wh_dispatch_requests" ] = this.wh_selected_dispatch_request_batch.map( this.mapSelected )

        //
        return this.sync({
            description: this.description,
            sl_customer_branch_offices_id: this.sl_customer_branch_offices_id,
            wh_detail_dispatch_request: this.wh_selected_dispatch_requests.map(
                this.mapSelected
            ),
        })
    }

    /*printTicket() {
        const sale = this.pos_sale
        const items = sale.pos_detail_sales
        const fullName = ({ names, last_name1 }) => {
            return `${names} ${last_name1}`
        }
        let win = window.open('dispatchRequest.html')
        win.window.title = null
        win.window.barcode = '123456789012'
        win.window.RUT = '76.958.430-7'
        win.window.billNum = this.id
        win.window.activities = 'VENTA AL POR MAYOR DE OTROS PRODUCTOS N.C.P'
        win.window.address = 'VICENTE ZORRILLA 835, LA SERENA'
        win.window.phone = ''
        win.window.seller = fullName(sale.g_seller_user.hr_employee)
        let dtt = this.created_at
            ? this.created_at.split(' ')
            : this.created_at.split(' ')
        win.window.date = dtt[0]
        win.window.time = dtt[1]

        win.window.cRUT = this.sl_customer.rut
        win.window.cBusinessName = this.sl_customer.business_name
        win.window.cPersonName = this.sl_customer.alias_nam
        win.window.cMail = this.sl_customer_branch_offices
            ? this.sl_customer_branch_offices.email
            : 'Sin correo.'
        win.window.cActivities = this.sl_customer.core_business
        win.window.cAddress = this.sl_customer_branch_offices
            ? this.sl_customer_branch_offices.address
            : ''
        win.window.cPhone = this.sl_customer_branch_offices
            ? this.sl_customer_branch_offices.phone
            : ''
        win.window.cCity = this.sl_customer_branch_offices
            ? this.sl_customer_branch_offices.city
            : ''
        win.window.cCommune =
            this.sl_customer_branch_offices &&
            this.sl_customer_branch_offices.g_commune
                ? this.sl_customer_branch_offices.g_commune.name
                : ''
        win.window.cZone = this.sl_customer_branch_offices
            ? this.sl_customer_branch_offices.zone
            : ''

        win.window.subtotal = sale.invoice_total

        win.window.total = sale.invoice_total
        win.window.roundLaw = 0 //getters.roundingLaw
        win.window.applyRoundLaw = false //state.lastPaymentMethod === 1
        // win.window.amountPaid = parseInt(getters.totalPaid)
        // win.window.change = parseInt(getters.change)
        win.window.discount =
            sale.discount_or_charge_percentage || sale.global_discount_value
        win.window.amountDiscount = sale.discount_or_charge_amount
        win.window.comment = JSON.parse(
            JSON.stringify(this.sale_comment)
                .split('\\n')
                .join('<br>')
        )

        // win.window.arrayPayments = state.arrayPayments

        // win.window.posSaleType = 2
        //console.log({ sale, items })
        win.window.items = items
    }*/
}
